import { Box, Typography } from '@mui/material';
import type { AgeRange, SuitabilityAnswers } from './answers';
import { RadioQuestion } from 'src/suitability/engine/components/radio-question';
import { useWioCapitalContent } from './content';

interface StepProps {
  answers: SuitabilityAnswers;
  onUpdate: (patch: Partial<SuitabilityAnswers>) => void;
}

export const StepPreData = ({ answers, onUpdate }: StepProps) => {
  const content = useWioCapitalContent();
  const step = content.step('preData');
  const age = content.age();

  return (
    <Box>
      <Typography variant="textXl" sx={{ fontWeight: 700, mb: 1 }}>
        {step.title}
      </Typography>
      <Typography
        variant="textSm"
        sx={{ color: 'text.secondary', mb: 3, display: 'block' }}
      >
        {step.intro}
      </Typography>

      <RadioQuestion
        question={age.prompt}
        options={age.options}
        value={answers.ageRange}
        onChange={(v) => onUpdate({ ageRange: v as AgeRange, p11: v as AgeRange })}
        required
      />
    </Box>
  );
};
